import { OrderByValues } from "@/root/types";

export const error404Message = "Сторінки не існує";

export const pages = {
  graphic: {
    path: "/",
    title: "Graphic",
    nav: true,
  },
  report: {
    path: "/report",
    title: "Report",
    nav: true,
  },
  settings: {
    path: "/settings",
    title: "Settings",
    nav: true,
  },
  admin: {
    path: "/admin",
    title: "Users",
    nav: true,
  },
  createUser: {
    path: "/create-user",
    title: "Create user",
    nav: false,
  },
  login: {
    path: "/login",
    title: "Login",
    nav: false,
  },
};

export const navLinks = Object.values(pages)
  .filter((link) => link.nav)
  .map((value) => ({
    path: value.path,
    title: value.title,
  }));

export const spBaudRates = [
  110, 300, 1200, 2400, 4800, 9600, 14400, 19200, 38400, 57600, 115200,
];

export const spDataBits = [5, 6, 7, 8];

export const spParities = ["none", "even", "odd"];

export const spStopBits = [1, 1.5, 2];

export const orderByOptions: { value: OrderByValues; title: string }[] = [
  { value: "old", title: "From old" },
  { value: "new", title: "From new" },
];
